import { writable } from "svelte/store";

const LAWYER_ACCENT_COLOR_KEY = "client-lawyer-accent-color";
const LAWYER_THEME_KEY = "client-lawyer-theme";

const token = localStorage.getItem("client-token");

export const saveTheme = (newTheme) => {
  theme.set(newTheme);
  localStorage.setItem(LAWYER_THEME_KEY, newTheme);
};

export const saveAccentColor = (newAccentColor) => {
  let root = document.documentElement;
  root.style.setProperty("--accent", newAccentColor);

  accentColor.set(newAccentColor);
  localStorage.setItem(LAWYER_ACCENT_COLOR_KEY, newAccentColor);
};

const getThemeFromStorage = () => {
  return localStorage.getItem(LAWYER_THEME_KEY);
};

const getAccentColorFromStorage = () => {
  return localStorage.getItem(LAWYER_ACCENT_COLOR_KEY);
};

const storedTheme = getThemeFromStorage();
const storedAccentColor = getAccentColorFromStorage();

export const authToken = writable(token);
export const currentClient = writable(null);
export const currentOrganization = writable(null);
export const sidebarCollapsed = writable(false);
export const theme = writable(storedTheme ? storedTheme : "dark");
export const accentColor = writable(
  storedAccentColor ? storedAccentColor : "#c03549",
);
